import { Button } from "antd";
import classNames from "classnames/bind";
import styles from "./AntdButtonCustom.module.css";

const cx = classNames.bind(styles);

function AntdButtonCustom({ className, title, ...props }) {
    return (
        <Button {...props} className={cx("btn", `${className}`)}>
            {title}
        </Button>
    )
}

export default AntdButtonCustom;